import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import styles from './styles.css'

class SubOrderFooter extends React.PureComponent {

  static propTypes = {
    subOrder: PropTypes.object.isRequired,
  }

  render() {

    const {
      subOrder,
    } = this.props

    return (

      <div className={styles.wrapper}>

        <div className={styles.totalsWrapper}>
          {subOrder.set_amount !== null && subOrder.set_amount !== undefined && (
            <div className={styles.total}>
              {`Subcontractor Total: ${subOrder.set_amount < 0 ? '-' : ''}£${numeral(Math.abs(subOrder.set_amount)).format('0,0.00')}`}
            </div>
          )}
          <div className={styles.total}>
            {`Company Total: ${subOrder.total < 0 ? '-' : ''}£${numeral(Math.abs(subOrder.total)).format('0,0.00')}`}
          </div>
        </div>

      </div>

    )

  }

}

export default SubOrderFooter
